import { styled } from "@mui/material";

import { Column } from "@rui/Stack";

export const Thumbnail = styled(Column)(({ theme }) => ({
  height: "97px",
  width: "172px",
  borderRadius: "4px",
  position: "relative",
  overflow: "hidden",
  objectFit: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  backgroundColor: theme.palette.shades.neutral[900],
  marginBottom: theme.spacing(0.5),
}));
